/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { condition } from './subs/condition';
import { diagnosisreference } from './subs/diagnosisreference';
import { procedure } from './subs/procedure';
import { servicedate } from './subs/servicedate';
import { previouscertification } from './subs/previouscertification';
import { relatedcause } from './subs/relatedcause';
import { provider_reference } from '../domain/provider_reference';
import { addressreference } from '../common/addressreference';
import { oxygenequipmenttype } from './subs/oxygenequipmenttype';
import { oxygentestresults } from './subs/oxygentestresults';
import { benefitscoordination } from './subs/benefitscoordination';
import { referenceidentification } from './subs/referenceidentification';
import { requestvalidation } from './subs/requestvalidation';

export class referral extends IceEntity {
  referral_key: string = "";
  trans_account: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  benefit_information_key: string = "";
  billing_provider_trans_account: string = "";
  billing_provider_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  requester_trans_account: string = "";
  requester_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  requester_provider_code: string = "";
  umo_key: string = "";
  certification_type_code: string = "";
  request_category_code: string = "";
  service_type_code: string = "";
  facility_code: string = "";
  facility_code_qualifier: string = "";
  level_of_service_code: string = "";
  currect_healthcondition_code: string = "";
  prognosis_code: string = "";
  release_of_information_code: string = "";
  delay_reason_code: string = "";
  accident_date: any = NaN
  onset_of_illness_date: any = NaN;
  last_menstrual: any = NaN;
  pregnant: boolean = false;
  estimated_dob: any = NaN;
  admission_type: string = "";
  admission_source_code: string = "";
  patient_status_code: string = "";
  nursing_home_status_code: string = "";
  service_quantity: number = 0;
  type_of_service_quantity: string = "";
  service_quantity_unit_code: string = "";
  number_of_periods: number = 0;
  time_period_qualifier: string = "";
  calendar_pattern_code: string = "";
  calendar_pattern_time_code: string = "";
  weight_unit_code: string = "";
  weight: number = 0.0;
  ambulance_transport_code: string = "";
  ambulance_transport_reason_code: string = "";
  transport_distance: number = 0.0;
  transport_distance_unit_code: string = "";
  round_trip_purpose_description: string = "";
  stretcher_purpose_description: string = "";
  subluxation_level_code: string = "";
  subluxation_end_level_code: string = "";
  treatment_series_number: number = 0;
  treatment_series_count: number = 0.0;
  treatment_period_unit_code: string = "";
  treatment_period_count: number = 0.0;
  monthly_treatment_period_count: number = 0.0;
  nature_of_condition_code: string = "";
  complication_code: string = "";
  condition_description: string = "";
  xray_available_code: string = "";
  home_health_certification_type_code: string = "";
  home_health_prognosis_code: string = "";
  home_health_start: any = NaN;
  home_health_period_begins: any = NaN;
  home_health_period_ends: any = NaN;
  skilled_nursing_facility_code: string = "";
  medicare_coverage_code: string = "";
  surgery_date: any = NaN;
  product_service_id_qualifer: string = "";
  surgical_procedure_code: string = "";
  physician_order_date: any = NaN;
  last_visit_date: any = NaN;
  last_physician_contact_date: any = NaN;
  last_admission_period_began: any = NaN;
  last_admission_period_ended: any = NaN;
  patient_discharge_facility_type: string = "";
  oxygen_equipment_reason_description: string = "";
  oxygen_flow_rate: number = 0.0;
  oxygen_daily_use_count: number = 0.0;
  oxygen_hour_use_count: number = 0.0;
  respiratory_therapist_description: string = "";
  arterial_blood_gas_quantity: number = 0.0;
  oxygen_saturation_quantity: number = 0.0;
  oxygen_test_condition_code: string = "";
  requester_message: string = "";
  response_message: string = "";
  certification_issue_date: any = NaN;
  certification_expiration_date: any = NaN;
  certification_effective_date: any = NaN;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  portable_oxygen_flow_rate: number = 0.0;
  oxygen_delivery_system_code: string = "";
  connection_parameters_key: string = "";
  hcr_certification_action_code: string = "";
  hcr_review_identification_number: string = "";
  hcr_review_decision_reason_code: string = "";

  DIAGS: diagnosisreference[] = [];
  PREVCERTS: previouscertification[] = [];
  CAUSES: relatedcause[] = [];
  CONDS: condition[] = [];
  PROS: provider_reference[] = [];
  SVCDTS: servicedate[] = [];
  PROCSRS: procedure[] = [];
  ORIGADS: addressreference[] = [];
  DESTADS: addressreference[] = [];
  OXYEQTS: oxygenequipmenttype[] = [];
  OXYPRTBLS: oxygenequipmenttype[] = [];
  OXYTRLTS: oxygentestresults[] = [];
  COOS: benefitscoordination[] = [];
  REQRESULTS: requestvalidation[] = [];
  IDS: referenceidentification[] = [];

  gettablename(): string {
    return "REFERRAL";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "PREVCERTS") return true;
    else if (ColumnName == "CAUSES") return true;
    else if (ColumnName == "CONDS") return true;
    else if (ColumnName == "PROS") return true;
    else if (ColumnName == "SVCDTS") return true;
    else if (ColumnName == "PROCSRS") return true;
    else if (ColumnName == "ORIGADS") return true;
    else if (ColumnName == "DESTADS") return true;
    else if (ColumnName == "OXYEQTS") return true;
    else if (ColumnName == "OXYPRTBLS") return true;
    else if (ColumnName == "OXYTRLTS") return true;
    else if (ColumnName == "COOS") return true;
    else if (ColumnName == "REQRESULTS") return true;
    else if (ColumnName == "IDS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "PREVCERTS") return "PREVIOUS_CERTIFICATION";
    else if (ColumnName == "CAUSES") return "RELATED_CAUSE";
    else if (ColumnName == "CONDS") return "CONDITION";
    else if (ColumnName == "PROS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "SVCDTS") return "SERVICE_DATE";
    else if (ColumnName == "PROCSRS") return "PROCEDURE";
    else if (ColumnName == "ORIGADS") return "ADDRESS_REFERENCE";
    else if (ColumnName == "DESTADS") return "ADDRESS_REFERENCE";
    else if (ColumnName == "OXYEQTS") return "OXYGEN_EQUIPMENT_TYPE";
    else if (ColumnName == "OXYPRTBLS") return "PORTABLE_OXYGEN_EQUIPMENT_TYPE";
    else if (ColumnName == "OXYTRLTS") return "OXYGEN_TEST_RESULTS";
    else if (ColumnName == "COOS") return "BENEFITS_COORDINATION";
    else if (ColumnName == "REQRESULTS") return "REQUEST_VALIDATION";
    else if (ColumnName == "IDS") return "REFERENCE_IDENTIFICATION";

    return null;
  }
}
